import { ReactNode } from 'react';
import { IconButtonV2 } from '@shared/components/MBButton';
import { View } from '@shared/components/View';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { Colors, grid } from '@shared/styles';
import { getTestId } from '@shared/util/getTestId';

interface RowProps {
  icon: MBIconV2Name;
  children: ReactNode;
  onDelete: VoidFunction;
  testID?: string;
}

export function Row({ icon, children, onDelete = () => {}, testID }: RowProps) {
  return (
    <View row centerVertically paddingVertical={1} paddingLeft={1} gap={1}>
      <div style={{ marginRight: grid(1) }}>
        <MBIconV2 name={icon} color={Colors.v2.purple} size={grid(3)} />
      </div>
      {children}
      <div style={{ marginLeft: grid(2) }}>
        <IconButtonV2
          name="trash"
          onPress={onDelete}
          size={grid(3)}
          color={Colors.v2.purple}
          testID={getTestId(testID, 'delete-button')}
        />
      </div>
    </View>
  );
}
